// $lib/stores/userOnboardingStore.ts
import { writable, get } from "svelte/store";
// import { browser } from "$app/environment";
import { goto } from "$app/navigation";
import { SubscriptionAPI } from "$lib/api/subscription";

interface SignUpIntent {
  plan: string | undefined;
  updatedAt: Date | undefined;
  originPage: string | undefined;
}

function createUserOnboardingStore() {
  const { subscribe, set } = writable<SignUpIntent>({
    plan: undefined,
    updatedAt: undefined,
    originPage: undefined,
  });

  // function saveToStorage(state: SignUpIntent): void {
  //   if (browser) {
  //     localStorage.setItem("signUpIntent", JSON.stringify({
  //       ...state,
  //       updatedAt: state.updatedAt?.toISOString()
  //     }));
  //   }
  // }

  // function loadFromStorage(): SignUpIntent | null {
  //   if (browser) {
  //     const stored = localStorage.getItem("signUpIntent");
  //     if (stored) {
  //       try {
  //         const parsed = JSON.parse(stored);
  //         return {
  //           ...parsed,
  //           updatedAt: parsed.updatedAt ? new Date(parsed.updatedAt) : undefined
  //         };
  //       } catch (e) {
  //         console.error("Failed to parse stored sign up intent:", e);
  //       }
  //     }
  //   }
  //   return null;
  // }

  // function clearStorage(): void {
  //   if (browser) {
  //     localStorage.removeItem("signUpIntent");
  //   }
  // }

  function isSearchPage(path: string): boolean {
    return path.startsWith("/search/");
  }

  return {
    subscribe,
    getPlan: (): string | undefined => {
      const state = get({ subscribe });
      return state.plan;
    },
    reset: () => {
      const newState: SignUpIntent = {
        plan: undefined,
        updatedAt: undefined,
        originPage: undefined,
      };
      set(newState);
      // clearStorage();
    },
    // User will be redirected to stripe checkout page after sign up if there is a plan in the store
    setSignUpIntent: (plan: string, currentPath?: string) => {
      logger.log(`Setting sign up intent for plan: ${plan}`);
      const newState: SignUpIntent = {
        plan,
        updatedAt: new Date(),
        originPage: currentPath,
      };
      set(newState);
    },
    checkAndProcessIntent: async () => {
      const state = get({ subscribe });

      if (state.plan && state.updatedAt) {
        const now = new Date();
        const timeDifference = now.getTime() - state.updatedAt.getTime();
        const minutesDifference = timeDifference / (1000 * 60);

        if (minutesDifference <= 20) {
          try {
            const referral = Rewardful ? Rewardful.referral : "";
            await SubscriptionAPI.checkout(state.plan, referral);

            const redirectPath = state.originPage && isSearchPage(state.originPage) ? state.originPage : "/";

            userOnboardingStore.reset();

            if (redirectPath !== "/") {
              goto(redirectPath);
            }
          } catch (error) {
            console.error("Failed to process subscription checkout:", error);
          }
        } else {
          userOnboardingStore.reset();
        }
      }
    },

    getOriginPage: (): string | undefined => {
      const state = get({ subscribe });
      return state.originPage;
    },
  };
}

export const userOnboardingStore = createUserOnboardingStore();
